/** Says when there is no connection and what is on the screen: a copy kept on the device, and how old it is. */

import { useTranslation } from "react-i18next";
import { useOfflineStatus } from "./status";
import { stockholmTime, localDay } from "../logbook/time";

export default function OfflineBar() {
  const { t } = useTranslation();
  const status = useOfflineStatus();
  if (!status.offline) return null;
  const from = status.servedFrom;
  return (
    <div role="status" className="bg-amber-100 px-4 py-2 text-center text-sm text-amber-950">
      <strong>{t("logbook.offline.noConnection")}</strong>{" "}
      {from
        ? from.expired
          ? t("logbook.offline.showingExpired", { day: localDay(from.at), time: stockholmTime(from.at) })
          : t("logbook.offline.showing", { day: localDay(from.at), time: stockholmTime(from.at) })
        : t("logbook.offline.nothingKept")}
    </div>
  );
}
